import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
import Select from 'react-select';
import { Link } from 'react-router-dom';

import * as api from '../../api/api';

class CustomContentFileShowPage extends React.Component {
    constructor(props) {
        super(props);

        let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");

        this.state = {
            returnUrl: returnUrl,
            displays: [],
            selectedDisplayIds: [],
            duration: 1,
            file: {
                name: "",
                type: ""
            },
            canSetDuration: true
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeDuration = this.handleChangeDuration.bind(this);
        this.handleOkButtonClick = this.handleOkButtonClick.bind(this);
    }

    async componentDidMount() {

        if (!api.isUserAdmin()) {
            this.setState({
                returnUrl: "/users/permission-denied",
                needRedirect: true
            });

            return;
        }

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        if (this.props.match.params.id != 0) {
            try {
                const allDevices = (await api.makeRequest(api.getDisplaysDictionary())).data.data;
                const fileAssignments = (await api.makeRequest(api.getCustomContentFileAssignment(this.props.match.params.id))).data.data;
                const fileDetails = (await api.makeRequest(api.getCustomContentFileDetails(this.props.match.params.id))).data.data;

                const listItems = [];

                for (const deviceId of fileAssignments) {
                    const deviceInfo = allDevices.find((device) => device.id === deviceId);
                    listItems.push({
                        value: deviceId,
                        label: `${deviceInfo.id} [${deviceInfo.checkpoint.name} - ${deviceInfo.checkpoint.description}]`,
                    });
                }

                this.setState({
                    file: {
                        name: fileDetails.name,
                        type: fileDetails.type,
                    },
                    canSetDuration: fileDetails.type.indexOf("video/") === -1,
                    displays: listItems,
                });

                this.props.updateLoader({
                    loaded: true,
                    message: ""
                });
            } catch (err) {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении данных: " + err
                });
            }
        }
    }

    handleChange(newItem) {
        this.setState({
            selectedDisplayIds: newItem
        });
    }

    handleChangeDuration(event) {
        this.setState({
            duration: event.target.value
        });
    }

    handleOkButtonClick() {

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        const displayIds = this.state.selectedDisplayIds.map(item => {
            return item.value
        })

        api.makeRequest(api.showCustomContent(this.props.match.params.id, {
            fileName: this.state.file.name,
            displayIds: displayIds,
            duration: this.state.duration
        })).then(
            (result) => {
                this.props.updateLoader({
                    loaded: true,
                    message: ""
                });
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при выполнении действия: " + error
                });
            }
        );
    }

    render() {
        return (

            <div>
                <h4 className="mb-4">Запуск отображения медиафайла "{this.state.file.name}"</h4>

                <form>
                    <div class="form-group">
                        <label className="mr-2">Табло</label>
                        <Select
                            isMulti
                            placeholder="Щёлкните для выбора..."
                            options={this.state.displays}
                            value={this.state.selectedDisplayIds}
                            onChange={this.handleChange}
                        />
                    </div>

                    <div class="form-group">
                        <label className="mr-2">Продолжительность (с.)</label>
                        <input disabled={!this.state.canSetDuration} className="form-control" type="number" min="1" value={this.state.duration} onChange={this.handleChangeDuration} />

                        {
                            !this.state.canSetDuration &&
                            <div className="alert alert-warning mt-1" role="alert">
                                Для видеофайлов установка продолжительности воспроизведения невозможна!
                            </div>
                        }

                    </div>
                </form>

                <div className="mt-4">
                    <button className="btn btn-primary-custom" onClick={this.handleOkButtonClick}>
                        OK
                    </button>
                    <button className="btn btn-secondary ml-2 btn-with-link" type="button">
                        <Link to={this.state.returnUrl}>Назад</Link>
                    </button>
                </div>
            </div>
        );
    }
}

export default CustomContentFileShowPage;


// import React from 'react';
// import "bootstrap/dist/css/bootstrap.css";
// import '../../assets/css/style.css';
// import { Link } from 'react-router-dom';

// import ItemMultiSelector from '../shared/CustomSelect';

// import * as api from '../../api/api';

// class CustomContentFileShowPage extends React.Component {
//     constructor(props) {
//         super(props);

//         let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");

//         this.state = {
//             returnUrl: returnUrl,
//             devices: [],
//             selectedGroupIds: [],
//             duration: 1,
//             file: {
//                 name: "",
//                 type: ""
//             },
//             canSetDuration: true
//         }

//         this.handleGroupsChange = this.handleGroupsChange.bind(this);
//         this.handleChangeDuration = this.handleChangeDuration.bind(this);
//         this.handleOkButtonClick = this.handleOkButtonClick.bind(this);
//     }

//     componentDidMount() {

//         if (!api.isUserAdmin()) {
//             this.setState({
//                 returnUrl: "/users/permission-denied",
//                 needRedirect: true
//             });

//             return;
//         }

//         this.props.updateLoader({
//             loaded: false,
//             message: ""
//         });

//         if (this.props.match.params.id != 0) {

//             api.makeRequest(api.getCustomContentFileAssignment(this.props.match.params.id)).then(
//                 response => {

//                     const deviceIds = response.data.data.assignment.map(assignment => {
//                         return assignment.displayId;
//                     });

//                     api.makeRequest(api.getDeviceGroups(deviceIds)).then(
//                         getGroupsResponse => {

//                             this.devices = response.data.data.assignment.map(item => {
//                                 return {
//                                     id: item.displayId,
//                                     groupId: getGroupsResponse.data.data.find(group => group.devices.find(device => device == item.displayId)).id,
//                                     checked: false
//                                 };
//                             });

//                             this.setState({
//                                 file: response.data.data.file,
//                                 canSetDuration: response.data.data.file.type.indexOf("video/") === -1,
//                                 groups: getGroupsResponse.data.data.map(group => {
//                                     return {
//                                         value: group.id,
//                                         label: group.name
//                                     };
//                                 })
//                             });

//                             this.props.updateLoader({
//                                 loaded: true,
//                                 message: ""
//                             });
//                         },
//                         (error) => {
//                             this.props.updateLoader({
//                                 loaded: true,
//                                 message: "Ошибка при получении данных: " + error
//                             });
//                         }
//                     );
//                 },
//                 error => {
//                     this.props.updateLoader({
//                         loaded: true,
//                         message: "Ошибка при получении данных: " + error
//                     });
//                 }
//             )
//         }
//     }

//     handleGroupsChange(groups) {

//         let newDevices = [];

//         groups.forEach(group => {
//             newDevices = newDevices.concat(this.devices
//                 .filter(device => device.groupId == group.value))
//                 .map(device => {
//                     return {
//                         id: device.id,
//                         checked: true
//                     }
//                 });
//         });

//         this.setState({
//             devices: newDevices,
//             devicesError: ""
//         });
//     }

//     handleChangeDuration(event) {
//         this.setState({
//             duration: event.target.value,
//             durationError: ""
//         });
//     }

//     handleOkButtonClick() {

//         let wasError = false;

//         const displayIds = this.state.devices.filter(device => device.checked).map(device => { return device.id });
//         if (displayIds.length == 0) {
//             this.setState({
//                 devicesError: "Пожалуйста, выберите группы и устройства"
//             });

//             wasError = true;
//         }

//         if (!this.state.duration || this.state.duration == 0) {
//             this.setState({
//                 durationError: "Пожалуйста, заполните это поле"
//             });

//             wasError = true;
//         }

//         if (wasError) {
//             return;
//         }

//         // return;

//         this.props.updateLoader({
//             loaded: false,
//             message: ""
//         });

//         api.makeRequest(api.showCustomContent({
//             fileName: this.state.file.name,
//             fileId: this.props.match.params.id,
//             displayIds: displayIds,
//             duration: this.state.duration
//         })).then(
//             (result) => {
//                 this.props.updateLoader({
//                     loaded: true,
//                     message: ""
//                 });
//             },
//             (error) => {
//                 this.props.updateLoader({
//                     loaded: true,
//                     message: "Ошибка при выполнении действия: " + error
//                 });
//             }
//         );
//     }

//     render() {
//         return (

//             <div>
//                 <h4 className="mb-4">Запуск отображения медиафайла "{this.state.file.name}"</h4>

//                 <form>
//                     <div class="form-group">
//                         <label className="mt-2">Группы устройств</label>

//                         <ItemMultiSelector
//                             isMulti
//                             isColored={false}
//                             options={this.state.groups}
//                             onChange={this.handleGroupsChange}
//                         />

//                         {
//                             this.state.devices.length > 0 &&
//                             <div className="alert alert-info" role="alert">
//                                 <label className="mt-2">Файл будет отображён на устройствах:</label>
//                                 <div>
//                                     {
//                                         this.state.devices.map(device => {
//                                             return (
//                                                 < div className="m-2" >
//                                                     <input class="form-check-input" type="checkbox"
//                                                         value={device.id}
//                                                         checked={device.checked}
//                                                         onChange={() => this.setState({
//                                                             devices: this.state.devices.map(item => {

//                                                                 if (item.id == device.id) {
//                                                                     item.checked = !item.checked;
//                                                                 }

//                                                                 return item;
//                                                             }),
//                                                             devicesError: ""
//                                                         })}
//                                                     />
//                                                     <label class="ml-2 form-check-label">
//                                                         {device.id}
//                                                     </label>
//                                                 </div>
//                                             )
//                                         })
//                                     }
//                                 </div>
//                             </div>
//                         }
//                         <div className="form-error-message">
//                             {this.state.devicesError}
//                         </div>

//                     </div>

//                     <div class="form-group">
//                         <label className="mt-2">Продолжительность (с.)</label>
//                         <input disabled={!this.state.canSetDuration} className="form-control" type="number" min="1" value={this.state.duration} onChange={this.handleChangeDuration} />

//                         {
//                             !this.state.canSetDuration &&
//                             <div className="alert alert-warning mt-1" role="alert">
//                                 Для видеофайлов установка продолжительности воспроизведения невозможна!
//                             </div>
//                         }
//                         <div className="form-error-message">
//                             {this.state.durationError}
//                         </div>
//                     </div>
//                 </form>

//                 <div className="mt-4">
//                     <button className="btn btn-primary-custom" onClick={this.handleOkButtonClick}>
//                         OK
//                     </button>
//                     <button className="btn btn-secondary ml-2 btn-with-link" type="button">
//                         <Link to={this.state.returnUrl}>Назад</Link>
//                     </button>
//                 </div>
//             </div>
//         );
//     }
// }

// export default CustomContentFileShowPage;